import Promise from 'promise-polyfill'
import helpers from '@/store/helpers'

const TripExpense = {
  namespaced: true,
  state: {
    items: null,
    categories: {}
  },
  mutations: {
    load (state, payload) {
      state.items = Object.assign([], payload)
    },
    loadCategory (state, payload) {
      state.categories[payload.category] = payload.expenses
    },
    reset (state, payload) {
      state.items = null
      state.categories = {}
    }
  },
  actions: {
    refresh: (context, payload) => helpers.refresh(context, payload,
      {backend: 'tripExpense', method: 'getTripExpenseTypesUsingGET', mutation: 'load', state: 'items'}),
    list: (context, payload) => helpers.list(context, payload, {action: 'refresh', state: 'items'}),
    refreshCategory: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.tripExpense.getTripExpenseGroupDetailUsingGET({categori: payload.category})
          .then(res => {
            context.commit('loadCategory', {category: payload.category, expenses: res.body})
            resolve(context.state.categories[payload.category])
          })
          .catch(err => reject(err))
      })
    },
    getCategory: (context, payload) => {
      const expenses = context.state.categories[payload.category]
      return new Promise((resolve, reject) => {
        if (typeof expenses !== 'undefined') {
          resolve(expenses)
        } else {
          context.dispatch('refreshCategory', payload)
            .then(res => resolve(res)).catch(err => reject(err))
        }
      })
    },
    reset: (context, payload) => context.commit('reset')
  }
}

export default TripExpense



// WEBPACK FOOTER //
// ./src/store/master/TripExpense.js